import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { useAirlineServices,useAirportConsultancy,useCommercialLeasing } from "../BusinessOppurtunities/BusinessOppurtunities.hook";
import { fields } from "../MediaCentre/constants";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import {Corporate} from "./Corporate/Corporate";
import {Airport} from "./Airport/Airport";

const ContactUs = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  useEffect(() => {
     const currentParams = new URLSearchParams(window.location.search);
    const id = currentParams.get("id"); 
    if(id){
      return;
    }
    if (!query.get("activeTab")) {
       navigate(
        `/dedicated/corporate/contactus?activeTab=corporate&subActiveTab=corporatePageHeading${id ? `&id=${id}` : ""}`,
        { replace: true }
      );
    } else {
      if(query.get('activeTab')==='corporate' && query.get('subActiveTab') === "corporatePageContent"){
       navigate(
        `/dedicated/corporate/contactus?activeTab=corporate&subActiveTab=${query.get("subActiveTab") || "corporatePageHeading"}&thirdChildActiveTab=${query.get('thirdChildActiveTab') ?? "corporateMap"}${id ? `&id=${id}` : ""}`,
        { replace: true }
      );
      }
      if(query.get('activeTab')==='corporate' && query.get('subActiveTab') !== "corporatePageContent"){
       navigate(
        `/dedicated/corporate/contactus?activeTab=corporate&subActiveTab=${query.get("subActiveTab") || "corporatePageHeading"}${id ? `&id=${id}` : ""}`,
        { replace: true }
      );
      }
      if(query.get('activeTab')==='airports'){
        navigate(`/dedicated/corporate/contactus?activeTab=airports&subActiveTab=${query.get("subActiveTab")|| 'airportsPageHeading'}`, {
          replace: true,
        });
      }
    }
  }, [query.get('activeTab'), query.get('subActiveTab')]);

 
  const items = [
    {
      label: "Corporate",
      key: "corporate",
      children: (
        <Corporate/>
      ),
    },
    {
      label: "Airports",
      key: "airports",
      children: (
        <Airport/>
      ),
    },
  ];

  return (
    <ContentWrapper
      title={"Contact Us"}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};

export default ContactUs